import { useMutation, useQueryClient } from "@tanstack/react-query";
import { agencySaleDetail } from "../../services/agencies-sales-details";
import { useGetMyProfile } from "../profile/use-get-my-profile";
import { AGENCIES_SALES_DETAILS_QUERY_KEY } from "./use-get-agencies-sales-details";
import { AGENCIES_SALES_TOTAL_QUERY_KEY } from "./use-get-agencies-sales-total";

// Estorno de uma venda já feita. Invalida as mesmas três coisas que a venda:
// o perfil (o estoque da revenda volta a subir), o total (a estornada sai da
// soma) e o histórico (a linha passa a aparecer marcada).
export const useReverseAgencySaleDetail = () => {
  const { invalidate } = useGetMyProfile();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: agencySaleDetail.reverse,
    onSettled: () => {
      invalidate();
      queryClient.invalidateQueries({
        queryKey: [AGENCIES_SALES_TOTAL_QUERY_KEY],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: [AGENCIES_SALES_DETAILS_QUERY_KEY],
        exact: false,
      });
    },
  });

  return {
    reverse: mutateAsync,
    isLoading,
  };
};
